import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

export function RouteAnalytics() {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    trackPageView({
      path: location.pathname,
      search: location.search,
      hash: location.hash,
      navigationType,
    });
  }, [location.hash, location.key, location.pathname, location.search, navigationType]);

  return null;
}
